import {
  AUTH_REDIRECT_ROUTE_PATH,
  RouteCallback,
} from "@package/ui-authentication";
import { ScheduledEventModificationType } from "@package/ui-gql/index-data-access";
import { Route, Routes } from "react-router";
import {
  ITEM_GRID_PATH_EDIT,
  ITEM_GRID_PATH_EDIT_SCHEDULER_GROUP,
  ITEM_GRID_PATH_NEW,
  SidebarEntryPath,
} from "../../constants/contants";
import { EventsGrid } from "./panels/events/EventsGrid";
import { LayoutEditPage } from "./panels/layout/LayoutEditPage";
import { LayoutGrid } from "./panels/layout/LayoutGrid";
import { LocationEdit } from "./panels/location/LocationEdit";
import { LocationGrid } from "./panels/location/LocationGrid";
import { MediaEdit } from "./panels/media/MediaEdit";
import { MediaGrid } from "./panels/media/MediaGridWithToolbar";
import { PostEditPage } from "./panels/post/PostEditPage";
import { PostGrid } from "./panels/post/PostGrid";
import { ProfileEditPage } from "./panels/profile/ProfileEditPage";
import { ProfileGrid } from "./panels/profile/ProfileGrid";
import { SchedulerCalendar } from "./panels/scheduler/SchedulerCalendar";
import { SchedulerEdit } from "./panels/scheduler/SchedulerEdit";
import { TagEditPage } from "./panels/tag/TagEditPage";
import { TagGrid } from "./panels/tag/TagGrid";

export function ContentSection() {
  return (
    <div className="h-full pl-4 pr-4">
      <Routes>
        <Route path="/">
          <Route index element={<LocationGrid />} />
          <Route path={AUTH_REDIRECT_ROUTE_PATH} element={<RouteCallback />} />
          <Route path={SidebarEntryPath.events}>
            <Route index element={<EventsGrid />} />
          </Route>
          <Route path={SidebarEntryPath.layout}>
            <Route index element={<LayoutGrid />} />
            <Route path={ITEM_GRID_PATH_NEW} element={<LayoutEditPage />} />
            <Route
              path={`${ITEM_GRID_PATH_EDIT}/:id`}
              element={<LayoutEditPage />}
            />
          </Route>
          <Route path={SidebarEntryPath.locations}>
            <Route index element={<LocationGrid />} />
            <Route path={ITEM_GRID_PATH_NEW} element={<LocationEdit />} />
            <Route
              path={`${ITEM_GRID_PATH_EDIT}/:id`}
              element={<LocationEdit />}
            />
          </Route>
          <Route path={SidebarEntryPath.media}>
            <Route index element={<MediaGrid />} />
            <Route path={ITEM_GRID_PATH_NEW} element={<MediaGrid />} />
            <Route
              path={`${ITEM_GRID_PATH_EDIT}/:id`}
              element={<MediaEdit />}
            />
          </Route>
          <Route path={SidebarEntryPath.posts}>
            <Route index element={<PostGrid />} />
            <Route path={ITEM_GRID_PATH_NEW} element={<PostEditPage />} />
            <Route
              path={`${ITEM_GRID_PATH_EDIT}/:id`}
              element={<PostEditPage />}
            />
          </Route>
          <Route path={SidebarEntryPath.profiles}>
            <Route index element={<ProfileGrid />} />
            <Route path={ITEM_GRID_PATH_NEW} element={<ProfileEditPage />} />
            <Route
              path={`${ITEM_GRID_PATH_EDIT}/:id`}
              element={<ProfileEditPage />}
            />
          </Route>
          <Route path={SidebarEntryPath.scheduler}>
            <Route index element={<SchedulerCalendar />} />
            <Route
              path={ITEM_GRID_PATH_NEW}
              element={
                <SchedulerEdit
                  modifyType={ScheduledEventModificationType.Single}
                />
              }
            />
            <Route
              path={`${ITEM_GRID_PATH_EDIT}/:id`}
              element={
                <SchedulerEdit
                  modifyType={ScheduledEventModificationType.Single}
                />
              }
            />
            <Route
              path={`${ITEM_GRID_PATH_EDIT_SCHEDULER_GROUP}/:id`}
              element={
                <SchedulerEdit
                  modifyType={ScheduledEventModificationType.All}
                />
              }
            />
          </Route>
          <Route path={SidebarEntryPath.tags}>
            <Route index element={<TagGrid />} />
            <Route path={ITEM_GRID_PATH_NEW} element={<TagEditPage />} />
            <Route
              path={`${ITEM_GRID_PATH_EDIT}/:id`}
              element={<TagEditPage />}
            />
          </Route>
        </Route>
      </Routes>
    </div>
  );
}
